import { render, staticRenderFns } from "./anJuanXinXi.vue?vue&type=template&id=5293213f&scoped=true"
import script from "./anJuanXinXi.vue?vue&type=script&lang=js"
export * from "./anJuanXinXi.vue?vue&type=script&lang=js"
import style0 from "./anJuanXinXi.vue?vue&type=style&index=0&id=5293213f&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5293213f",
  null
  
)

export default component.exports